export class LoadEvent {
    static _id = 0;
    constructor (obj) {
        this.object = obj;
        this._id = LoadEvent._id;
        LoadEvent._id++;
    }

    is(loadEvent) {
        return this._id === loadEvent._id;
    }
}